import Vue, { VueConstructor, } from 'vue';
import App from '~/components/feedback-article/feedback-article.vue';

Vue.config.productionTip = false;

interface FeedbackFormOptions {
	id: string;
	reasons: string[];
}

export function FeedbackForm(layout: VueConstructor<Vue>, props: FeedbackFormOptions, mountPoint: string) {
	new Vue({
		render: (h) => h(layout, [h(App, {
			props,
		}),]),
	}).$mount(mountPoint);
}
